import React from "react";
import AboutAreaTwo from "../components/AboutAreaTwo";
import BannerTwo from "../components/BannerTwo";
import CounterAreaTwo from "../components/CounterAreaTwo";
import NavbarTwo from "../components/NavbarTwo";
import TestimonialOne from "../components/TestimonialOne";
import ServiceAreaFour from "../components/ServiceAreaFour";
import FooterThree from "../components/FooterThree";
import WorkProcessFour from "../components/WorkProcessFour";
import ProjectAreaOne from "../components/ProjectAreaOne";

const HomeTwo = () => {
  return (
    <>
      {/* Navigation Bar Two*/}
      <NavbarTwo />

      {/* Banner Two */}
      <BannerTwo />

      {/* About Area Two */}
      <AboutAreaTwo />

      {/* About Area Two */}
      <ServiceAreaFour />

      {/* Pricing Area Two */}

      {/* Counter Area Two */}
      <CounterAreaTwo />

      {/* Contact Area Two */}
      {/* <ContactAreaTwo /> */}


      {/* Work Process Two */}
      <WorkProcessFour/>

  {/* Project Area One */}
  <ProjectAreaOne />
      {/* Testimonial One */}
      <TestimonialOne />

      {/* Blog Area Two */}
      {/* <BlogAreaTwo /> */}

      {/* Footer Two */}
      <FooterThree />
    </>
  );
};

export default HomeTwo;
